module.exports = __webpack_public_path__ + "static/cordura-d8ba9dde6c0805b993b1997241f790c1.png";